import { useTranslation } from "react-i18next";
import { ECONTRACT_STATUS } from "../../../../../../enums";
import { getMappedContractStatus } from "./constants";
import styles from "./styles.module.scss";

interface StatusPillProps {
  status: ECONTRACT_STATUS;
}

const StatusPill = ({ status }: StatusPillProps) => {
  const { t } = useTranslation();

  const statusData = getMappedContractStatus(status, t);

  if (!statusData) {
    return null;
  }

  return (
    <div
      style={{
        color: statusData.color,
        backgroundColor: statusData.backgroundColor,
      }}
      className={styles.container}>
      {statusData.title}
    </div>
  );
};

export default StatusPill;
